import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { Download, Maximize, Minimize, X } from "lucide-react";
import { IMAGE_BASE_URL } from "../../config/api";
import ListHeader from "../../molecules/ListHeader/ListHeader";

const ImageView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const imageUrl = location.state?.imageUrl;
  const title = location.state?.title || "Image View";

  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };


  const handleDownload = async () => {
    try {
      const response = await fetch(IMAGE_BASE_URL + imageUrl, {
        mode: "cors",
      });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${imageUrl}.jpg`; 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url); // clean up memory
    } catch (error) {
      console.error("Failed to download image:", error);
    }
  };
  if (!imageUrl) {
    return <div>No image found</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <ListHeader
        mainHeading={title}
        placeholder="Search"
        btnShow={false}
        linkBreadCrum="/expenses"
        blinkBreadCrumText={title}
        searchShow={false}
        showLikeFilter={false}
        DropDown={false}
      />

      <div className="relative w-full h-[calc(100vh-80px)] bg-black">
        {/* Image Controls */}
        <div className="absolute top-4 right-4 z-20 flex gap-2 bg-black/50 p-2 rounded-lg">
          <Button 
            icon={isFullscreen ? <Minimize size={16} /> : <Maximize size={16} />}
            onClick={handleFullscreen}
            className="bg-transparent border-none text-white hover:bg-white/20 rounded transition-all duration-300"
          />
          <Button 
            icon={<Download size={16} />}
            onClick={handleDownload}
            className="bg-transparent border-none text-white hover:bg-white/20 rounded transition-all duration-300"
          />
          <Button 
            icon={<X size={16} />}
            onClick={() => navigate(-1)}
            className="bg-transparent border-none text-white hover:bg-white/20 rounded transition-all duration-300"
          />
        </div>

        {/* Image */}
        <div className="w-full h-full flex items-center justify-center">
          <img
            src={IMAGE_BASE_URL + imageUrl}
            alt="Full Screen Image"
            className="max-w-full max-h-full object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default ImageView; 